import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';
import { UserInfo } from '../collections/api/user/user-info.interface';

function initSentry(app: App, router: Router) {
   const browserTracing = new BrowserTracing({ routingInstrumentation: Sentry.vueRouterInstrumentation(router) });
   const enabled = ['acc', 'prd', 'release'].includes(import.meta.env.VITE_APP_ENV);

   Sentry.init({
      app,
      attachProps: true,
      attachStacktrace: true,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      enabled,
      environment: import.meta.env.VITE_APP_ENV,
      integrations: [browserTracing],
      logErrors: true,
      maxBreadcrumbs: 50,
      release: import.meta.env.VITE_APP_VERSION,
      tracesSampleRate: import.meta.env.VITE_APP_SENTRY_SAMPLING,
      trackComponents: true,
      ignoreErrors: [
         'Request aborted',
         'Network error',
         'Fetch error',
         'XHR error',
         'adsbygoogle',
         'Failed to fetch',

         'Request failed with status code 418',
         'Request failed with status code 409',
         'Request failed with status code 422',
         'Request failed with status code 404',
         'Request failed with status code 403',
         'Request failed with status code 405',
         'Request failed with status code 500',
         'Request failed with status code 400',

         // TODO: Remove when Yentl fixes dashboard issue
         'Event `CustomEvent` (type=error) captured as exception',

         // npm library errors
         "Cannot read properties of undefined (reading 'data')",
         'undefined',
      ],
   });
}

function identifySentryUser(user?: UserInfo) {
   if (user) {
      Sentry.setUser({ username: `${user.first_name} ${user.last_name}`, email: user.email, id: user.id.toString() });
   } else {
      Sentry.setUser(null);
   }
}

export { identifySentryUser, initSentry };
